import React from "react";

const LogosSection = () => {
  const logos = [
    { name: "Netlify", icon: "cloud_done" },
    { name: "Product Hunt", icon: "rocket_launch" },
    { name: "Indie Hackers", icon: "groups" },
    { name: "DEV India", icon: "terminal" },
    { name: "Webflow", icon: "web" },
  ];

  return (
    <section
      id="trusted-by"
      className="py-14 sm:py-20 bg-white border-t border-[#E2E8F0]"
    >
      <div className="mx-auto w-[95%] md:w-[90%]">
        <div className="mx-auto max-w-3xl text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0B1C2D] sm:text-4xl animate-fade-in-up">
            Trusted by developers, startups, and{" "}
            <br className="hidden sm:block" />
            <span className="text-[#E63946]">
              digital agencies across India.
            </span>
          </h2>
          <p className="mt-4 text-base sm:text-lg leading-7 sm:leading-8 text-[#64748B] animate-fade-in-up [animation-delay:100ms]">
            Join hundreds of teams building smarter customer experiences with
            ContactHQ.
          </p>
        </div>

        <div className="mx-auto grid grid-cols-2 items-center gap-x-4 gap-y-10 sm:gap-x-8 sm:gap-y-12 sm:grid-cols-3 lg:grid-cols-5">
          {logos.map((brand, index) => (
            <div
              key={brand.name}
              className="group flex flex-col items-center justify-center opacity-0 animate-fade-in-up"
              style={{ animationDelay: `${200 + index * 100}ms` }}
            >
              <div className="flex flex-col items-center gap-3 sm:gap-4 grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500">
                <div className="flex h-10 sm:h-12 items-center justify-center">
                  <span className="material-symbols-outlined text-3xl sm:text-4xl text-[#0B1C2D] group-hover:text-[#E63946] transition-all duration-300">
                    {brand.icon}
                  </span>
                </div>
                <span className="text-[11px] sm:text-sm font-bold tracking-[0.1em] text-[#0B1C2D] uppercase text-center px-1">
                  {brand.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogosSection;
